// MI stock bar, live. Keeps every "N of M left" bar on the page in step with the store's stock
// while a shopper has the page open: asks /products/<handle>?view=mi-stock for the count on load,
// every 30 seconds while the tab is showing, and whenever the shopper comes back to the tab.
// A bar opts in with data-mi-stock="<product url>", data-mi-start (the starting quantity),
// data-mi-soldout (the words for zero), a [data-mi-stock-left] number and a [data-mi-stock-fill] bar.
(() => {
  const EVERY = 30000;
  const bars = () => [...document.querySelectorAll('[data-mi-stock]')];
  if (!bars().length || window.__miStockLive) return;
  window.__miStockLive = true;

  function paint(bar, left) {
    const start = Number(bar.dataset.miStart);
    if (!start || left > start) return;
    if (left <= 0) {
      bar.textContent = bar.dataset.miSoldout || '';
      // The sold-out next step (mi-next-deal box, best sellers row) is drawn hidden while the
      // drop is on sale; show it for this product the moment it sells out.
      document.querySelectorAll('[data-mi-soldout-show]').forEach((el) => {
        if (el.dataset.miSoldoutShow === bar.dataset.miStock) el.hidden = false;
      });
      return;
    }
    const n = bar.querySelector('[data-mi-stock-left]');
    const fill = bar.querySelector('[data-mi-stock-fill]');
    if (n && n.textContent !== String(left)) n.textContent = left;
    if (fill) fill.style.width = Math.floor((left * 100) / start) + '%';
  }

  async function refresh() {
    if (document.hidden) return;
    const urls = [...new Set(bars().map((b) => b.dataset.miStock))];
    for (const url of urls) {
      try {
        const r = await fetch(`${url}?view=mi-stock&_=${Date.now()}`, { cache: 'no-store' });
        if (!r.ok) continue;
        const d = JSON.parse((await r.text()).trim());
        if (typeof d.left !== 'number') continue;
        bars().filter((b) => b.dataset.miStock === url).forEach((b) => paint(b, d.left));
      } catch (e) {
        // A failed check leaves the bar as it was; the next one tries again.
      }
    }
  }

  refresh();
  setInterval(refresh, EVERY);
  document.addEventListener('visibilitychange', refresh);
})();
